import React, { FC } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { Sizes } from "src/@types/sizes";
import { Avatar } from "src/components/Avatar";
import { Link } from "src/components/Link";
import { getItemPath } from "src/utils/getItemPath";
import { PATHNAMES } from "src/constants/routes";
import { Roles } from "src/@types/users";
import { dealCardTrns } from "./trns";
import { de } from "date-fns/locale";

interface Props {
  userName: string;
  avatarUrl: string;
  userId: number;
  userRole: Roles;
  isLabelOutside?: boolean;
  className?: string;
}

export const UserLabel: FC<Props> = ({
  userName,
  userRole,
  avatarUrl,
  isLabelOutside = false,
  userId,
  className,
}) => {
  const { t } = useTranslation();

  const label =
    userRole === Roles.AGENT
      ? t(dealCardTrns.agentLabel)
      : t(dealCardTrns.ownerLabel);

  return (
    <div
      className={cn(
        "md:flex items-center justify-start gap-5 flex-1 w-full text-purple-base",
        {
          [className]: isLabelOutside,
        }
      )}
    >
      {isLabelOutside && (
        <span className="font-semibold block md:hidden lg:block">{label}:</span>
      )}
      <Link
        href={getItemPath(PATHNAMES.USER_PROFILE, { id: userId })}
        className={cn(
          "flex items-center justify-start gap-5 px-5 py-2 min-w-50 lg:min-w-72 border flex-1 bg-gray-light md:bg-white-pink border-black-base/20 rounded-20 hover:bg-gray-light",
          {
            [className]: !isLabelOutside,
          }
        )}
      >
        <Avatar sizeVariant={Sizes.XS} avatarUrl={avatarUrl} />
        <div className="flex items-center justify-center">
          <p className="flex flex-col gap-0.5 items-start leading-none">
            {!isLabelOutside && <span className="font-semibold">{label}:</span>}
            <span>{userName}</span>
          </p>
        </div>
      </Link>
    </div>
  );
};
